var map = {
	"./assetSummary.png": 2886,
	"./barChart.png": 2887,
	"./battery.png": 2888,
	"./batteryExchange.png": 2889,
	"./batteryLevel.png": 2890,
	"./cages.png": 2891,
	"./deployment.png": 2892,
	"./distribution.png": 2893,
	"./favouriteAssets.png": 2894,
	"./favouritePeople.png": 2895,
	"./favouriteZone.png": 2896,
	"./floorplan.png": 2897,
	"./guage.png": 2898,
	"./hours.png": 2899,
	"./lifecycle.png": 2900,
	"./lineChart.png": 2901,
	"./map.png": 2902,
	"./peopleSummary.png": 2903,
	"./recentItem.png": 2904,
	"./zoneSummary.png": 2905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642;